import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { experimentalStyled } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import MenuIcon from "../../icons/Menu";
import qtravel from "../../icons/qtravel.svg";
import AccountPopover from "./AccountPopover";
import useAuth from "../../hooks/useAuth";

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === "light" && {
    backgroundColor: theme.palette.primary.main,
    boxShadow: "none",
    color: theme.palette.primary.contrastText,
  }),
  ...(theme.palette.mode === "dark" && {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: "none",
  }),
  zIndex: theme.zIndex.drawer + 100,
}));

const DashboardNavbar = (props) => {
  const { onSidebarMobileOpen, ...other } = props;
  const { user } = useAuth();

  return (
    <DashboardNavbarRoot {...other}>
      <Toolbar sx={{ minHeight: 64 }}>
        <Box display={{ xs: "block", lg: "none" }}>
          <IconButton color="inherit" onClick={onSidebarMobileOpen}>
            <MenuIcon fontSize="small" />
          </IconButton>
        </Box>
        <Box>
          <RouterLink to="/dashboard/overview">
            <img src={qtravel} alt="logo"></img>
          </RouterLink>
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            ml: 2,
          }}
        />
        {user && user.email && (
          <Typography color="white" variant="h6" data-testid="email">
            {user.email}
          </Typography>
        )}
        <Box sx={{ ml: 2 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
    </DashboardNavbarRoot>
  );
};

DashboardNavbar.propypes = {
  onSidebarMobileOpen: PropTypes.func,
};

export default DashboardNavbar;
